import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IGameRepresentationChangedArgs, IGame } from '@/components/game/_domain/models';
import TombolaBaseComponent from '@/components/base/base.component';
import { TombolaRouletteController, ITombolaRouletteGameRepresentation } from '@/components/game/implementations/uk/tombola-roulette/_domain/controller/game-controller';
import { getPathToCallImagesFolder } from '@/components/game/_domain';
import eventBus from '@/plugins/event-bus';

@Component({
  name: 'TombolaRouletteLastCallsComponent'
})

export default class TombolaRouletteLastCallsComponent extends TombolaBaseComponent {
  @Prop() public gameController: TombolaRouletteController;
  private callhistory: string[] = [];
  private pathToCallImage: string = '';
  private callsAsImages: boolean = false;

  private mounted() {
    Vue.nextTick(() => {
      this.gameController
          .onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });

    const game = this.gameController.getGame();
    this.setSkin(game);
  }

  private setSkin(game: IGame) {
    const gameIdentity = game.gameIdentity;
    const gameConfig = game.gameConfiguration;
    this.callsAsImages = gameConfig.showCallsAsImages;
    this.pathToCallImage = getPathToCallImagesFolder(gameIdentity.name, gameIdentity.clubName, gameConfig.callSkins);
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    this.callhistory = (eventArgs.currentGameRepresentation as ITombolaRouletteGameRepresentation).callhistory;
  }

  private renderCallImage(callValue: string) {
    return `${this.pathToCallImage}${callValue}.png`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/tombola-roulette/_components/last-calls/last-calls.component.ts